import { useEffect, useRef, useState } from 'react';

type BackoffTypes = 'linear' | 'exponential';

const calculateTimeout = (interval: number, requestCount: number, backoff?: BackoffTypes) => {
  if (backoff === 'linear') {
    return interval * requestCount;
  } else if (backoff === 'exponential') {
    return Math.pow(2, requestCount) * interval + Math.round(Math.random() * interval);
  } else {
    return interval;
  }
};

export const usePoll = (
  refetch: () => void,
  isPolling?: boolean | ((requestCount: number) => boolean),
  config?: {
    interval?: number;
    backoff?: BackoffTypes;
    shouldResetBackoff?: (requestCount: number) => boolean;
  },
) => {
  const interval = config?.interval || 5000;
  const [requestCount, setRequestCount] = useState<number>(0);
  const intervalId = useRef<number>();

  useEffect(() => {
    if ((typeof isPolling === 'function' && isPolling(requestCount)) || isPolling === true) {
      intervalId.current = setTimeout(() => {
        setRequestCount(requestCount + 1);
        refetch();
      }, calculateTimeout(interval, requestCount, config?.backoff));
    } else {
      clearTimeout(intervalId.current);
    }
    return () => clearTimeout(intervalId.current);
  }, [requestCount, isPolling]);

  useEffect(() => {
    if (config?.shouldResetBackoff && config.shouldResetBackoff(requestCount)) {
      setRequestCount(0);
    }
  }, [config, requestCount]);
};
